var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaignStatsSubmissions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.23223 1.56561C3.70107 1.09677 4.33696 0.833374 5 0.833374H11.6667C11.8877 0.833374 12.0996 0.921171 12.2559 1.07745L17.2559 6.07745C17.4122 6.23373 17.5 6.44569 17.5 6.66671V16.6667C17.5 17.3297 17.2366 17.9656 16.7678 18.4345C16.2989 18.9033 15.663 19.1667 15 19.1667H5C4.33696 19.1667 3.70107 18.9033 3.23223 18.4345C2.76339 17.9656 2.5 17.3297 2.5 16.6667V3.33337C2.5 2.67033 2.76339 2.03445 3.23223 1.56561ZM5 2.50004C4.77899 2.50004 4.56702 2.58784 4.41074 2.74412C4.25446 2.9004 4.16667 3.11236 4.16667 3.33337V16.6667C4.16667 16.8877 4.25446 17.0997 4.41074 17.256C4.56702 17.4122 4.77899 17.5 5 17.5H15C15.221 17.5 15.433 17.4122 15.5893 17.256C15.7455 17.0997 15.8333 16.8877 15.8333 16.6667V7.01188L11.3215 2.50004H5Z",
    fill: "#161719"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6666 0.833374C12.1268 0.833374 12.4999 1.20647 12.4999 1.66671V5.83337H16.6666C17.1268 5.83337 17.4999 6.20647 17.4999 6.66671C17.4999 7.12695 17.1268 7.50004 16.6666 7.50004H11.6666C11.2063 7.50004 10.8333 7.12695 10.8333 6.66671V1.66671C10.8333 1.20647 11.2063 0.833374 11.6666 0.833374Z",
    fill: "#161719"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83325 10.8333C5.83325 10.3731 6.20635 10 6.66659 10H13.3333C13.7935 10 14.1666 10.3731 14.1666 10.8333C14.1666 11.2936 13.7935 11.6667 13.3333 11.6667H6.66659C6.20635 11.6667 5.83325 11.2936 5.83325 10.8333Z",
    fill: "#161719"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83325 14.1667C5.83325 13.7065 6.20635 13.3334 6.66659 13.3334H13.3333C13.7935 13.3334 14.1666 13.7065 14.1666 14.1667C14.1666 14.6269 13.7935 15 13.3333 15H6.66659C6.20635 15 5.83325 14.6269 5.83325 14.1667Z",
    fill: "#161719"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.83325 7.49996C5.83325 7.03972 6.20635 6.66663 6.66659 6.66663H8.33325C8.79349 6.66663 9.16659 7.03972 9.16659 7.49996C9.16659 7.9602 8.79349 8.33329 8.33325 8.33329H6.66659C6.20635 8.33329 5.83325 7.9602 5.83325 7.49996Z",
    fill: "#161719"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaignStatsSubmissions);
export default __webpack_public_path__ + "static/media/campaign-stats-submissions.b3cdcea8671df4d4c704881d1bb8ef47.svg";
export { ForwardRef as ReactComponent };